(function () {
  function initCartToggles() {
    var root = document.querySelector('[data-cart-toggles]');
    if (!root) return;

    root.addEventListener('click', function (e) {
      var btn = e.target.closest('.cart-toggle-btn');
      if (!btn) return;

      var panelId = btn.getAttribute('aria-controls');
      var panel = document.getElementById(panelId);
      if (!panel) return;

      var expanded = btn.getAttribute('aria-expanded') === 'true';

      // Close others (accordion)
      root.querySelectorAll('.cart-toggle-btn[aria-expanded="true"]').forEach(function (b) {
        if (b !== btn) b.setAttribute('aria-expanded', 'false');
      });
      root.querySelectorAll('.cart-toggle-panel:not([hidden])').forEach(function (p) {
        if (p !== panel) p.hidden = true;
      });

      // Toggle current
      btn.setAttribute('aria-expanded', String(!expanded));
      panel.hidden = expanded;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCartToggles);
  } else {
    initCartToggles();
  }
})();
